(() => {
  if(customElements.get('vics-studio-videos')) return;
  let currentVideo;
  function stop(video){
    if(!video) return;
    video.pause();
    video.removeAttribute('src');
    video.load();
    video.hidden=true;
    const card=video.closest('.vics-studio__card');
    card?.querySelector('.vics-studio__play')?.removeAttribute('hidden');
    card?.querySelector('.vics-studio__poster')?.removeAttribute('hidden');
    const status=card?.querySelector('[role="status"]');
    if(status){status.hidden=true;status.textContent='';}
    if(currentVideo===video) currentVideo=null;
  }
  class StudioVideos extends HTMLElement{
    connectedCallback(){
      if(this.abort) return;
      this.abort=new AbortController();
      const {signal}=this.abort;
      this.addEventListener('click',e=>{
        const play=e.target.closest('.vics-studio__play');
        if(play){
          const card=play.closest('.vics-studio__card'),video=card.querySelector('video'),status=card.querySelector('[role="status"]');
          if(currentVideo && currentVideo!==video) stop(currentVideo);
          currentVideo=video;
          const moveFocus=document.activeElement===play;
          status.textContent='Loading video…';status.hidden=false;video.hidden=false;
          if(moveFocus){video.tabIndex=0;video.focus();}
          play.hidden=true;
          video.poster=card.querySelector('.vics-studio__poster')?.currentSrc || '';
          card.querySelector('.vics-studio__poster')?.setAttribute('hidden','');
          video.src=video.dataset.src;
          video.play().then(()=>{if(currentVideo!==video)return;status.hidden=true;if(document.activeElement===play)video.focus();}).catch(()=>{if(currentVideo!==video)return;const restore=document.activeElement===play || document.activeElement===video;stop(video);status.textContent='The video could not play. Please try again.';status.hidden=false;if(restore)play.focus();});
        }
        const arrow=e.target.closest('[data-step]');
        if(arrow){const list=this.querySelector('.vics-studio__list');list.scrollBy({left:Number(arrow.dataset.step)*list.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
      },{signal});
      this.querySelectorAll('video').forEach(video=>{
        video.addEventListener('playing',()=>{video.closest('article').querySelector('[role="status"]').hidden=true;},{signal});
        video.addEventListener('error',()=>{if(currentVideo!==video)return;const card=video.closest('article'),status=card.querySelector('[role="status"]'),play=card.querySelector('.vics-studio__play');const restore=document.activeElement===video || document.activeElement===play;stop(video);status.textContent='The video is unavailable. Please try again shortly.';status.hidden=false;if(restore)play.focus();},{signal});
      });
      const list=this.querySelector('.vics-studio__list'),nav=this.querySelector('.vics-studio__nav');
      if(nav){
        const update=()=>{nav.hidden=list.scrollWidth<=list.clientWidth+2;nav.querySelector('[data-step="-1"]').disabled=list.scrollLeft<2;nav.querySelector('[data-step="1"]').disabled=list.scrollLeft+list.clientWidth>=list.scrollWidth-2;};
        list.addEventListener('scroll',update,{passive:true,signal});
        this.resize=new ResizeObserver(update);this.resize.observe(list);update();
      }
      this.observer=new IntersectionObserver(entries=>{for(const entry of entries){if(!entry.isIntersecting && currentVideo && entry.target.contains(currentVideo)) stop(currentVideo);}}, {threshold:0});
      this.querySelectorAll('.vics-studio__media').forEach(el=>this.observer.observe(el));
    }
    disconnectedCallback(){if(currentVideo && this.contains(currentVideo))stop(currentVideo);this.abort?.abort();this.abort=null;this.observer?.disconnect();this.resize?.disconnect();}
  }
  customElements.define('vics-studio-videos',StudioVideos);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)stop(currentVideo)});
})();
